import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { useFilterType } from '../state/filters'

export default function FilterTypeSignatures() {
  const [filterType, setFilterType] = useFilterType()
  return (
    <Select value={filterType} onValueChange={value => setFilterType(value as 'todos' | 'clientes' | 'usuarios')}>
      <SelectTrigger className="w-full md:w-[200px] bg-input">
        <SelectValue placeholder="Filtrar por tipo" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="todos">Todos</SelectItem>
        <SelectItem value="clientes">Clientes</SelectItem>
        <SelectItem value="usuarios">Parceiros</SelectItem>
      </SelectContent>
    </Select>
  )
}
